import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'msmeLoader',
  watch: {
    currentPage: function() {
      this.getMsmeExcelData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getMsmeExcelData();
    }
  },
  data() {
    return {
      showExcelUploadModal: false,
      fileName: null,
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      msmeData: [],
      msmeFields: [       
        {
          key: 'file_name'
        },
        {
          key: 'verify_msme_status'
        },
        {
          key: 'vendor_code'
        },
        {
          key: 'msme_no'
        },
        {
          key: 'enterprise_type'
        },
        {
          key: 'name_of_enterprise'
        },
        {
          key: 'major_activity'
        },
        {
          key: 'date_of_incorporation'
        },
        {
          key: 'email'
        },
        {
          key: 'date_of_registration'
        },
        {
          key: 'msme_error_msg'
        },
      ]
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'upload') {
          this.showExcelUploadModal = true;
        }
        // if (actionName === 'download') {
        //   this.loader = true;
        //   const downloadpayload = { ...this.panBankExcelPayload };
        //   downloadpayload._limit = this.totalRows;
        //   this.downloadExcel.downloadData(
        //     downloadpayload,
        //     'twoSixASUpload/getPankBankExcelData',
        //     'PAN BANK VERIFIED DATA',
        //     () => (this.loader = false)
        //   );
        // }
      }
    });
  },
  methods: {
    getMsmeExcelData() {
      this.panBankExcelPayload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        file_name: this.fileName
      };
      this.loader = true;
      this.$store
        .dispatch(
          'twoSixASUpload/getMsmeVerifiedExcelData',
          this.panBankExcelPayload
        )
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.msmeData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    clearFilters() {
      this.fileName = null;
    }
  }
};
